import { useState } from 'react';

const ContactButton: React.FC<{
  text: string,
  href: string,
  className: string,
  style?: object,
  icon?: React.ReactNode | React.ReactNode[],
  phoneNumber?: string
}> = ({ text, style, href, className, icon, phoneNumber }) => {

  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  if (phoneNumber) {

    return (
      <a style={style} className={`${className} cursor-pointer`} onClick={() => {setShowPhoneNumber(true)}}>
        {
          showPhoneNumber ? <a href={href} className='mr-1'>Call {phoneNumber}</a> : 
          (
            <>
            
            {
            icon ?
            <span className='mr-1'>{icon}</span>
            : null

            }
            {text}

            </>
          )
        }

      </a>
    )

  } else {

    return (
      <a style={style} className={className} href={href}>
        {
          icon ?
            <span className='mr-1'>{icon}</span>
            : null

        }
        {text}
      </a>
    )

  }
};


export default ContactButton